import React, { Key } from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';

import { EPCheckbox } from '@/comp';
import DynamicControllerIcon from '@/assets/dynamic-controller.svg?react';
import MaintenanceIcon from '@/assets/maintenance.svg?react';

interface ExtendedNotificationRowsProps {
  field: {
    name: string | number;
    fieldKey?: Key;
  };
  isFormDisabled: boolean;
}

const ExtendedNotificationRows: React.FC<ExtendedNotificationRowsProps> = ({ field, isFormDisabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="notification-settings-row-container">
        <div className="severity-container">
          <DynamicControllerIcon />
          <span className="label">{t('Dynamic Controller')}</span>
        </div>
        <div className="notification-description-container">
          {t('Notifies when the Dynamic Controller is turned On or Off')}
        </div>
        <div className="notification-preference-container">
          <Form.Item
            {...field}
            name={[field.name, 'subscriptions', 'DynamicController', 'email']}
            key={[field.fieldKey, 'subscriptions.DynamicController.email'] as unknown as Key}
            valuePropName={'checked'}
          >
            <EPCheckbox disabled={isFormDisabled}>{t('Email')}</EPCheckbox>
          </Form.Item>
        </div>
      </div>

      <div className="notification-settings-row-container">
        <div className="severity-container">
          <MaintenanceIcon />
          <span className="label">{t('Maintenance')}</span>
        </div>
        <div className="notification-description-container">
          {t("Notifies when a Device's Maintenance flag is changed")}
        </div>
        <div className="notification-preference-container">
          <Form.Item
            {...field}
            name={[field.name, 'subscriptions', 'InMaintenance', 'email']}
            key={[field.fieldKey, 'subscriptions.InMaintenance.email'] as unknown as Key}
            valuePropName={'checked'}
          >
            <EPCheckbox disabled={isFormDisabled}>{t('Email')}</EPCheckbox>
          </Form.Item>
        </div>
      </div>

      <div className="notification-settings-row-container">
        <div className="severity-container">
          <MaintenanceIcon />
          <span className="label">{t('Station Switch')}</span>
        </div>
        <div className="notification-description-container">{t('Notifies when a Station is switched On or Off')}</div>
        <div className="notification-preference-container">
          <Form.Item
            {...field}
            name={[field.name, 'subscriptions', 'StationSwitchToggleNotification', 'email']}
            key={[field.fieldKey, 'subscriptions.StationSwitchToggleNotification.email'] as unknown as Key}
            valuePropName={'checked'}
          >
            <EPCheckbox disabled={isFormDisabled}>{t('Email')}</EPCheckbox>
          </Form.Item>
        </div>
      </div>
    </>
  );
};

export default ExtendedNotificationRows;
